import { render, staticRenderFns } from "./messageDialog.vue?vue&type=template&id=396aefb8&scoped=true"
import script from "./messageDialog.vue?vue&type=script&lang=js"
export * from "./messageDialog.vue?vue&type=script&lang=js"
import style0 from "./messageDialog.vue?vue&type=style&index=0&id=396aefb8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396aefb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/xrUxRsdL/0/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('396aefb8')) {
      api.createRecord('396aefb8', component.options)
    } else {
      api.reload('396aefb8', component.options)
    }
    module.hot.accept("./messageDialog.vue?vue&type=template&id=396aefb8&scoped=true", function () {
      api.rerender('396aefb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialog/messageDialog.vue"
export default component.exports